import { Card, CardContent } from "@/components/ui/card";
import OptimizedImage from "@/components/OptimizedImage";
import garageBeforeImg from "@/assets/garage-before.jpg";
import garageAfterImg from "@/assets/garage-after.jpg";
import basementBeforeImg from "@/assets/basement-before.jpg";
import basementAfterImg from "@/assets/basement-after.jpg";

const BeforeAfterGallery = () => {
  const transformations = [
    {
      id: 1,
      before: garageBeforeImg,
      after: garageAfterImg,
      title: "Garage Organization",
      description: "Complete garage transformation with custom storage systems and clear zones for tools, seasonal items, and household supplies."
    },
    {
      id: 2,
      before: basementBeforeImg,
      after: basementAfterImg,
      title: "Basement Storage",
      description: "Professional basement organization with labeled storage solutions and efficient workflow systems."
    }
  ];

  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif font-light mb-6">
            Real Transformations
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            See the dramatic difference our professional organization services make in Michigan homes
          </p>
        </div>

        <div className="grid grid-cols-1 gap-12 max-w-6xl mx-auto">
          {transformations.map((item) => (
            <Card key={item.id} className="overflow-hidden border-border bg-card hover-lift">
              <CardContent className="p-0">
                <div className="grid md:grid-cols-2 gap-0">
                  <div className="relative">
                    <div className="aspect-[4/3] relative">
                      <OptimizedImage
                        src={item.before} 
                        alt={`${item.title} before organizing - cluttered space needing professional organization`}
                        width={400}
                        height={300}
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute top-3 left-3 bg-destructive/90 backdrop-blur-sm text-destructive-foreground px-3 py-1 text-sm font-medium rounded shadow-lg">
                        BEFORE
                      </div>
                    </div>
                  </div>
                  <div className="relative">
                    <div className="aspect-[4/3] relative">
                      <OptimizedImage
                        src={item.after} 
                        alt={`${item.title} after organizing - professionally organized space`}
                        width={400}
                        height={300}
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute top-3 left-3 bg-green-600/90 backdrop-blur-sm text-white px-3 py-1 text-sm font-medium rounded shadow-lg">
                        AFTER
                      </div>
                    </div>
                  </div>
                </div>
                <div className="p-6 text-center">
                  <h3 className="text-xl font-serif font-medium mb-2">{item.title}</h3>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Inspiration Images */}
        <div className="mt-16">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-serif font-light mb-4">
              Your Space, Elevated
            </h3>
            <p className="text-muted-foreground">
              Creating calm, functional spaces that reflect your lifestyle
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <Card className="overflow-hidden border-border bg-card">
              <CardContent className="p-0">
                 <div className="aspect-square relative">
                   <OptimizedImage
                     src="/lovable-uploads/85e7cc8e-da9b-4008-b5b9-298ebebad704.png" 
                     alt="Organized modern living space with plants and natural light - Michigan home organization"
                     width={400}
                     height={400}
                     className="w-full h-full object-cover"
                   />
                 </div>
              </CardContent>
            </Card>
            
            <Card className="overflow-hidden border-border bg-card">
              <CardContent className="p-0">
                 <div className="aspect-square relative">
                   <OptimizedImage
                     src="/lovable-uploads/9c140064-27be-41e6-88d6-c34a304242e4.png" 
                     alt="Beautifully organized shelving with plants and decor - luxury home organization Michigan"
                     width={400}
                     height={400}
                     className="w-full h-full object-cover"
                   />
                 </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BeforeAfterGallery;